import API from 'api/helpers/client';
import type {
  IVintelligenceDecodeVinElement,
  IVintelligenceDecodeVinParams,
  IVintelligenceMakesElement,
  IVintelligenceMakesParams,
  IVintelligenceModelsElement,
  IVintelligenceModelsParams,
} from './vintelligence.types';

export const fetchVintelligenceMakes = async (
  params: IVintelligenceMakesParams,
): Promise<IVintelligenceMakesElement[]> => {
  const { data } = await API.post(`/vintelligence/makes`, params);

  return data;
};

export const fetchVintelligenceModels = async (
  params: IVintelligenceModelsParams,
): Promise<IVintelligenceModelsElement[]> => {
  const { data } = await API.post(`/vintelligence/models`, params);

  return data;
};

export const fetchVintelligenceDecodeVIN = async (
  params: IVintelligenceDecodeVinParams,
): Promise<IVintelligenceDecodeVinElement[]> => {
  const { data } = await API.post(`/vintelligence/decode-vin`, params);

  return data;
};
